import type { ComponentType } from "react";
import ArrowRight from "@/components/icons/ArrowRight";
import Check from "@/components/icons/Check";
import Close from "@/components/icons/Close";
import Fire from "@/components/icons/Fire";
import Clock from "@/components/icons/Clock";
import Plus from "@/components/icons/Plus";
import Share from "@/components/icons/Share";
import Question from "./Question";
import Home from "./Home";
import Globe from "./Globe";
import Mail from "./Mail";
import Bell from "./Bell";
import Palette from "./Palette";
import ThumbUp from "./ThumbUp";
import Printer from "./Printer";
import PlusBox from "./PlusBox";
import LightBulb from "./LightBulb";
import Wand from "./Wand";
import Cup from "./Cup";
import Gift from "./Gift";

export const ICON_KEYS = [
    "arrow-right",
    "fire",
    "plus",
    "share",
    "check",
    "close",
    "question",
    "mail",
    "bell",
    "home",
    "palette",
    "globe",
    "thumb-up",
    "plus-box",
    "reply",
    "clock",
    "printer",
    "light-bulb",
    "wand",
    "cup",
    "gift"
] as const;

export type IconKey = (typeof ICON_KEYS)[number];

export const iconRegistry: Record<IconKey, ComponentType<object>> = {
    "arrow-right": ArrowRight,
    fire: Fire,
    plus: Plus,
    share: Share,
    check: Check,
    close: Close,
    question: Question,
    mail: Mail,
    bell: Bell,
    home: Home,
    palette: Palette,
    globe: Globe,
    "thumb-up": ThumbUp,
    "plus-box": PlusBox,
    reply: Globe,
    clock: Clock,
    printer: Printer,
    "light-bulb": LightBulb,
    wand: Wand,
    cup: Cup,
    gift: Gift
};

export function getIconByKey(key?: string | null) {
    if (!key) return null;
    return key in iconRegistry ? iconRegistry[key as IconKey] : null;
}
